import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { injectIntl } from 'react-intl'
import moment from 'moment'
import { getPewScoreStatus } from 'helpers/environmentMonitor'
import { mathRound } from 'helpers/math'
import messages from './translate'

class ListWrapper extends Component {
  getColor = data => {
    switch (parseInt(data, 10)) {
      case 1:
        return 'yellow'

      case 2:
        return 'green'

      case 0:
      default:
        return 'red'
    }
  }

  render() {
    const {
      intl: { formatMessage },
      listItem,
      licenseeName,
    } = this.props
    if (!listItem) return null

    return (
      <Grid item lg={4} md={5} sm={12} xs={12}>
        <Paper className="sensor-list pew-list">
          <div className="current-time">{`${formatMessage(
            messages.today,
          )} - ${moment(listItem.time).format('HH')}:00`}</div>
          <div
            className={`current-type pew-${getPewScoreStatus(listItem.score)}`}>
            <span className="name">PEW</span>
            <span className="value">{`${listItem.score}%`}</span>
          </div>
          <ul className="detail-list">
            <li className="list-item" key={listItem.saturation}>
              <span className="name">{`${formatMessage(
                messages.saturation,
              )} (%)`}</span>
              <span className="value">{mathRound(listItem.saturation)}</span>
            </li>
            <li
              className={`list-item ${this.getColor(listItem.pew_oxygen)}`}
              key={listItem.oxygen}>
              <span className="name">{`${formatMessage(
                messages.oxygen,
              )} (mg/l)`}</span>
              <span className="value">{mathRound(listItem.oxygen)}</span>
            </li>
            {licenseeName !== 'Aquachile' && (
              <>
                <li className="list-item" key={listItem.visibility}>
                  <span className="name">{`${formatMessage(
                    messages.transparency,
                  )} (m)`}</span>
                  <span className="value">
                    {mathRound(listItem.visibility)}
                  </span>
                </li>
                <li
                  className={`list-item ${this.getColor(listItem.pew_speed)}`}
                  key={listItem.speed}>
                  <span className="name">{`${formatMessage(
                    messages.speed,
                  )} (cm/s)`}</span>
                  <span className="value">{mathRound(listItem.speed)}</span>
                </li>
              </>
            )}
            <li className="list-item" key={listItem.cloud_cover}>
              <span className="name">{`${formatMessage(
                messages.cloudCover,
              )} (%)`}</span>
              <span className="value">{mathRound(listItem.cloud_cover)}</span>
            </li>
            <li
              className={`list-item ${this.getColor(listItem.pew_tide)}`}
              key={listItem.tide}>
              <span className="name">{`${formatMessage(
                messages.tide,
              )} (m)`}</span>
              <span className="value">{mathRound(listItem.tide)}</span>
            </li>
            <li
              className={`list-item ${this.getColor(listItem.pew_temperature)}`}
              key={listItem.temperature}>
              <span className="name">Water Temp (°C)</span>
              <span className="value">{mathRound(listItem.temperature)}</span>
            </li>
          </ul>
        </Paper>
      </Grid>
    )
  }
}

export default injectIntl(ListWrapper)
